import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from "@material-ui/icons/Delete";
import { BannerDetails_banner_category } from "@saleor/banners/types/BannerDetails";
import CardTitle from "@saleor/components/CardTitle";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableHead from "@saleor/components/TableHead";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection } from "../../../misc";
export interface BannerCategoryProps {
  category: BannerDetails_banner_category;
  onCategoryAssign?: () => void;
  onCategoryUnassign?: (id: string) => void;
  disabled?: boolean;
  onRowClick: (id: string) => void;
}

const useStyles = makeStyles(
  theme => ({
    buttonDisabled: {
      "& > span": {
        color: "#616161"
      }
    },
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 76 + theme.spacing(0.5)
    },
    colEmpty: {
      width: "1px"
    },
    colName: {
      paddingLeft: 0,
      width: 230
    },
    colNameLabel: {},
    colPrice: {
      textAlign: "center",
      width: 100
    },
    colPublished: {
      width: 150
    },
    colSKU: {
      "@media (min-width: 769px)": {
        wordBreak: "break-all"
      },
      width: 150
    },
    colType: {
      width: 150
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "BannerCategories" }
);

const numberOfColumnsVoucher = 4;

const BannerCategory: React.FC<BannerCategoryProps> = props => {
  const {
    category,
    onCategoryAssign,
    onCategoryUnassign,
    disabled
    // onRowClick
  } = props;
  const classes = useStyles(props);

  const intl = useIntl();

  function showProductTable() {
    const categoryData = category ? [category] : [];

    return (
      <ResponsiveTable className={classes.table}>
        <colgroup>
          <col className={classes.colName} />
          <col className={classes.colType} />
          <col className={classes.colActions} />
        </colgroup>
        <TableHead
          colSpan={numberOfColumnsVoucher}
          disabled={false}
          hideCheckBox
          items={[category]}
          toolbar={toolbar}
        >
          <TableCell className={classes.colName}>
            <span className={classes.colNameLabel}>
              <FormattedMessage defaultMessage="Category Name" />
            </span>
          </TableCell>
          <TableCell className={classes.colType}>
            <FormattedMessage defaultMessage="Category Level" />
          </TableCell>
          <TableCell className={classes.colType}>
            <FormattedMessage defaultMessage="No. of Products" />
          </TableCell>
          <TableCell className={classes.colActions} />
        </TableHead>
        <TableBody>
          {renderCollection(
            categoryData,
            (category, index) => (
              <TableRow
                hover={!!category}
                key={category ? category.id : "skeleton"}
                className={classes.tableRow}
              >
                <TableCell
                  className={classes.colName}
                  id={`catergoryNameRow${index}`}
                >
                  {maybe<React.ReactNode>(() => category.name, <Skeleton />)}
                </TableCell>
                <TableCell
                  className={classes.colType}
                  id={`categoryLevelRow${index}`}
                >
                  {maybe<React.ReactNode>(() => category.level, <Skeleton />)}
                </TableCell>
                <TableCell
                  className={classes.colType}
                  id={`categoryCountRow${index}`}
                >
                  {maybe<React.ReactNode>(
                    () => category.products.totalCount,
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell
                  className={classes.colActions}
                  id={`categoryUnassignBtnRow${index}`}
                >
                  <IconButton
                    disabled={!category}
                    onClick={event => {
                      event.stopPropagation();
                      onCategoryUnassign(category.id);
                    }}
                  >
                    <DeleteIcon color="primary" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={numberOfColumnsVoucher}>
                  <FormattedMessage defaultMessage="Click Assign Category to add a featured category in this list" />
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </ResponsiveTable>
    );
  }

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Featured Category",
          description: "section header"
        })}
        toolbar={
          <Button
            id="assignCategoryBtn"
            disabled={!!category || disabled}
            color="primary"
            className={!!category || disabled ? classes.buttonDisabled : null}
            onClick={onCategoryAssign}
          >
            <FormattedMessage
              defaultMessage="Assign category"
              description="button"
            />
          </Button>
        }
      />
      {showProductTable()}
    </Card>
  );
};
BannerCategory.displayName = "BannerCategory";
export default BannerCategory;
